import { BaseModel, convertToArrayModels, convertToModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toDateFormatComma } from '~/shared/utils/date'
import { toCroppedImage } from '~/shared/utils/image'
import VideoCard from '~/models/cards/VideoCard'
import ResearchShowcaseUniversity from './ResearchShowcaseUniversity'
import ResearchShowcaseParticipant from './ResearchShowcaseParticipant'
import ResearchShowcaseDetailFilter from './ResearchShowcaseDetailFilter'
import ResearchShowcaseProjectLink from './ResearchShowcaseProjectLink'
import ResearchShowcaseProjectFile from './ResearchShowcaseProjectFile'
import ResearchShowcaseGrantPatent from './ResearchShowcaseGrantPatent'

export default class ResearchShowcaseDetail extends BaseModel {
  static override constructorName = 'ResearchShowcaseDetail'

  id: number = 0
  name: string = ''
  slug: string = ''
  'main_image': string = ''
  'short_description': string = ''
  description: string = ''
  'author_name': string = ''
  university: ResearchShowcaseUniversity | null = null
  'author_photo': string = ''
  'profile_links': string = ''
  'team_description': string = ''
  'digital_lecture_videos': VideoCard[] = []
  'implementation_plans': string = ''
  'project_links': ResearchShowcaseProjectLink[] = []
  'project_files': ResearchShowcaseProjectFile[] = []
  'team_search': string = ''
  achievements: string = ''
  'grants_patents': ResearchShowcaseGrantPatent[] = []
  'social_significance': string = ''
  filters: ResearchShowcaseDetailFilter[] = []
  'is_published': boolean = false
  'date_publication': string = ''
  'likes_count': number = 0
  'views_count': number = 0
  'is_liked': boolean = false
  participants: ResearchShowcaseParticipant[] = []

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data, [
      'university',
      'digital_lecture_videos',
      'project_links',
      'project_files',
      'grants_patents',
      'filters',
      'participants',
    ])

    this.main_image = toCroppedImage(this.main_image)
    this.author_photo = toCroppedImage(this.author_photo)

    this.university = convertToModel(data.university, ResearchShowcaseUniversity)
    this.digital_lecture_videos = convertToArrayModels(data.digital_lecture_videos, VideoCard)
    this.project_links = convertToArrayModels(data.project_links, ResearchShowcaseProjectLink)
    this.project_files = convertToArrayModels(data.project_files, ResearchShowcaseProjectFile)
    this.grants_patents = convertToArrayModels(data.grants_patents, ResearchShowcaseGrantPatent)
    this.filters = convertToArrayModels(data.filters, ResearchShowcaseDetailFilter)
    this.participants = convertToArrayModels(data.participants, ResearchShowcaseParticipant)

    if (this.date_publication) {
      this.date_publication = toDateFormatComma(this.date_publication)
    }
  }
}

registerModel(ResearchShowcaseDetail)
